export const pageLoadingCss = `html:has(.pinedale-days-mount:not([data-pinedale-ready])) #sp-wrapper{visibility:hidden}html:has(.pinedale-days-mount:not([data-pinedale-ready]))::before{content:"Loading your devotional…";position:fixed;inset:0;z-index:2147483646;display:grid;place-content:center;padding-top:64px;background:#fffaf0;color:#263e36;font:16px/1.5 system-ui;text-align:center}html:has(.pinedale-days-mount:not([data-pinedale-ready]))::after{content:"";position:fixed;left:calc(50% - 16px);top:calc(50% - 32px);z-index:2147483647;width:32px;height:32px;border:3px solid #263e3626;border-top-color:#263e36;border-radius:50%;animation:pinedale-page-loading .8s linear infinite}@keyframes pinedale-page-loading{to{transform:rotate(360deg)}}@media(prefers-reduced-motion:reduce){html:has(.pinedale-days-mount:not([data-pinedale-ready]))::after{animation:none}}`;

import { configureBackdrop } from "./backdrop";
import { effectivePageTheme, applyPageLayerPresentation } from "./page-layers";
export function artworkCss(selector: string) {
  return (
    baseArtworkCss(selector) +
    `${selector}::after{display:var(--artwork-display,block)}`
  );
}
function baseArtworkCss(selector: string) {
  return `${selector}{overflow:hidden;pointer-events:none;background:var(--background-base,#e9e2d4)}${selector}::before,${selector}::after{content:"";position:absolute;pointer-events:none;background-repeat:no-repeat;opacity:var(--background-opacity,1)}${selector}::before{display:var(--blur-display,none);inset:-32px;clip-path:inset(min(100%,calc(var(--sharp-height,100%) + 32px)) 0 0 0);filter:blur(24px);background-image:linear-gradient(rgb(0 0 0 / var(--darkness,0)),rgb(0 0 0 / var(--darkness,0))),var(--blur-image,none);background-position:var(--x,50%) var(--y,0%);background-size:cover}${selector}::after{inset:0;background-image:var(--background-image,none);background-position:var(--x,50%) top;background-size:100% auto;filter:brightness(calc(1 - var(--darkness,0)));mask-image:var(--artwork-mask,none)}`;
}

export const readerBackgroundCss = `${artworkCss(".scene")}.scene{overflow-x:clip;overflow-y:visible;pointer-events:auto;--background-base:var(--secondary,var(--fallback));--background-image:var(--desktop,none)}.scene::before,.scene::after{z-index:-1}:host([site-background]) .scene{background:transparent;overflow-x:clip;overflow-y:visible;aspect-ratio:auto;min-height:max(640px,calc(100vw*var(--artwork-ratio,.5625) + var(--artwork-offset,0px)))}:host([site-background]) .scene::before,:host([site-background]) .scene::after{display:none}@media(max-width:640px){.scene{--background-image:var(--mobile,var(--desktop,none))}}.scene[data-artwork-device="mobile"]{--background-image:var(--mobile,var(--desktop,none))}`;

export function installPageBackground(mount: HTMLElement) {
  const wrapper = mount.closest<HTMLElement>("#sp-wrapper");
  const header = wrapper?.querySelector<HTMLElement>("#sp-header");
  const footer = wrapper?.querySelector<HTMLElement>("#sp-footer");
  if (!wrapper || !header || !footer) return;
  let background = wrapper.querySelector<HTMLElement>(
    ":scope > .pinedale-site-background",
  );
  if (!background) {
    const style = document.createElement("style");
    style.textContent = `${artworkCss(".pinedale-site-background")}.pinedale-bg-wrapper{position:relative;isolation:isolate}.pinedale-site-background{position:absolute;left:0;top:0;width:100%;z-index:0;--background-image:var(--desktop,none)}.pinedale-bg-through{background-color:transparent!important;background-image:none!important}.pinedale-bg-header{background-color:transparent!important;background-image:none!important}.pinedale-bg-header::before,.pinedale-bg-header::after{background:transparent!important}.pinedale-bg-content{position:relative;z-index:1}@media(max-width:640px){.pinedale-site-background{--background-image:var(--mobile,var(--desktop,none))}}.pinedale-site-background[data-artwork-device="mobile"]{--background-image:var(--mobile,var(--desktop,none))}`;
    document.head.append(style);
    const headerStyle = document.createElement("style");
    headerStyle.textContent =
      ".pinedale-bg-wrapper{min-height:100dvh!important}.pinedale-bg-header{position:relative;z-index:2}.pinedale-bg-wrapper .pinedale-mobile-image,.pinedale-obsolete-artwork{display:none!important}";
    document.head.append(headerStyle);
    wrapper.querySelectorAll(".pinedale-mobile-image").forEach((image) => {
      const section = image.closest(".sp-section");
      if (section && !section.contains(mount))
        section.classList.add("pinedale-obsolete-artwork");
    });
    const footerStyle = document.createElement("style");
    footerStyle.textContent = `.pinedale-bg-footer{position:relative;z-index:1}.pinedale-bg-footer,.pinedale-bg-footer .sp-section,.pinedale-bg-footer .sp-section-slide,.pinedale-bg-footer .sp-section-content,.pinedale-bg-footer #sp-footer-extra{background-color:transparent!important;background-image:none!important}.pinedale-footer-box{box-sizing:border-box;padding:20px!important;border:8px solid transparent;border-radius:16px;background:rgb(16 24 22 / .8)!important;background-clip:padding-box!important;color:#fff!important}.pinedale-footer-box :is(h1,h2,h3,h4,p,span,a:not(.sp-button)){color:#fff!important}.pinedale-footer-inline{display:inline-block;width:auto;max-width:100%;text-wrap:pretty}.pinedale-footer-box a:focus-visible{outline:3px solid #a0cc39;outline-offset:4px}.pinedale-footer-box a:hover{text-decoration:underline}@media(max-width:640px){.pinedale-footer-box{padding:16px!important;border-width:6px}}`;
    document.head.append(footerStyle);
    const footerCleanupStyle = document.createElement("style");
    footerCleanupStyle.textContent =
      ".pinedale-bg-footer :is(.sp-section,.sp-section-slide,.sp-section-content,.sp-grid,.sp-row,.sp-col,.sp-block,#sp-footer-extra):not(.pinedale-footer-box){background-color:transparent!important;background-image:none!important}.pinedale-bg-footer .sp-heading-block :is(span,h1,h2,h3,h4){background:transparent!important}";
    document.head.append(footerCleanupStyle);
    footer.classList.add("pinedale-bg-footer");
    footer.style.setProperty("display", "none", "important");
    const decorateFooter = () => {
      footer
        .querySelectorAll<HTMLElement>(".sp-row > .sp-col")
        .forEach((column) => {
          if (column.querySelector(".sp-text-block,.sp-heading-block"))
            column.classList.add("pinedale-footer-box");
        });
      footer
        .querySelectorAll<HTMLElement>(
          ".sp-text-block > .sp-block-content,.sp-heading-block > .sp-block-content,.sp-social-holder,#sp-footer-brand",
        )
        .forEach((block) => {
          if (!block.closest(".pinedale-footer-box"))
            block.classList.add(
              "pinedale-footer-box",
              "pinedale-footer-inline",
            );
        });
    };
    decorateFooter();
    new MutationObserver(decorateFooter).observe(footer, {
      childList: true,
      subtree: true,
    });
    background = document.createElement("div");
    background.className = "pinedale-site-background";
    background.setAttribute("aria-hidden", "true");
    wrapper.prepend(background);
    wrapper.classList.add("pinedale-bg-wrapper");
    header.classList.add("pinedale-bg-header");
    const layer = background;
    const resize = () => {
      mount.style.setProperty(
        "--artwork-offset",
        `${wrapper.getBoundingClientRect().top - mount.getBoundingClientRect().top}px`,
      );
      const bottom =
        wrapper.getBoundingClientRect().bottom -
        wrapper.getBoundingClientRect().top;
      layer.style.height = Math.max(0, bottom) + "px";
    };
    const observer = new ResizeObserver(resize);
    observer.observe(wrapper);
    observer.observe(header);
    observer.observe(footer);
    window.addEventListener("resize", resize);
    window.addEventListener("load", resize, { once: true });
    resize();
  }
  for (
    let node: HTMLElement | null = mount;
    node && node !== wrapper;
    node = node.parentElement
  ) {
    node.classList.add("pinedale-bg-through");
  }
  wrapper.querySelector("#sp-content")?.classList.add("pinedale-bg-content");
  return (
    theme: Record<string, any>,
    api: string,
    layoutDevice?: "desktop" | "mobile",
  ) => {
    background!.style.setProperty(
      "--background-base",
      theme.secondary || "#fffaf0",
    );
    background!.style.setProperty("--darkness", String(theme.darkness ?? 0));
    background!.style.setProperty(
      "--background-opacity",
      String(theme.backgroundOpacity ?? 1),
    );
    background!.style.setProperty("--x", `${theme.x ?? 50}%`);
    background!.style.setProperty("--y", `${theme.y ?? 0}%`);
    for (const key of ["desktop", "mobile"]) {
      if (theme[key])
        background!.style.setProperty(
          `--${key}`,
          `url("${new URL(theme[key], api).href.replaceAll('"', "%22")}")`,
        );
      else background!.style.removeProperty(`--${key}`);
    }
    const device =
      layoutDevice ??
      (matchMedia("(max-width:640px)").matches ? "mobile" : "desktop");
    background!.dataset.artworkDevice = device;
    configureBackdrop(background!, theme, api, device);
    applyPageLayerPresentation(
      background!,
      null,
      effectivePageTheme(theme, device),
      device,
    );
  };
}
